import React, { Component } from 'react';
import { connect } from 'react-redux';
import { renterSchema } from '../../helpers/renterSchema';
import {
  createRenter,
} from '../../duck/renter';
import {
  Button,
  Header,
  Form,
  Segment,
} from 'semantic-ui-react';

class RenterAdd extends Component {
  state = {
    email: '',
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmit = (e) => {
    e.preventDefault();

    this.props.dispatch(createRenter(this.props.id, this.state.email))
  }

  render() {
    return (
      <Segment padded>
        <Header
          size="huge"
          textAlign="center"
          style={{ fontSize: '3em' }}
        >
          <Header.Content content="Renter Information" />
          <Header.Subheader>
            Enter the renter's email to get started...
          </Header.Subheader>
        </Header>
        <Form size="large">
          <Form.Input
            label="Email"
            name="email"
            onChange={this.handleChange}
            value={this.state.email}
          />
          <Button
            content="Submit"
            primary
            disabled={!renterSchema.fields.email.isValidSync(this.state.email)}
            onClick={this.onSubmit}
            size="large"
            fluid
          />
        </Form>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return {
    id: state.id,
  }
}

export default connect(mapStateToProps)(RenterAdd);
